import React, { Fragment, memo } from 'react'

import { Typo } from 'components/_old/Typo/Typo'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { OwnerDetails } from 'app/pages/Dashboard/TransferIsa/TransferIsa/components/OwnerDetails'

const PensionDetails = memo(
  (): React.ReactElement => (
    <Fragment>
      <Typography size={24} weight="semibold" lineHeight="small">
        <Typo>Pension details</Typo>
      </Typography>
      <Paper top={32}>
        <Typography size={14}>
          <Typo>
            <p>
              Please enter all the details of your existing pension on this form. If there are any bits of information
              you don't have, or if you have any questions about this form, you can contact our Customer Support Team
              who will help you through the process.
            </p>
            <p>
              If you have more than one pension plan you wish to transfer into your InvestEngine Pension Plan then
              please complete a separate form for each.
            </p>
          </Typo>
        </Typography>
      </Paper>
      <Paper top={32}>
        <OwnerDetails size={14} />
      </Paper>
    </Fragment>
  ),
)
PensionDetails.displayName = 'PensionDetails'

export { PensionDetails }
